function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#231F20"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M30,1.7C21,1.7,13.7,9,13.7,18S21,34.3,30,34.3S46.3,27,46.3,18S39,1.7,30,1.7z M30,31.8 c-7.6,0-13.8-6.2-13.8-13.8S22.4,4.2,30,4.2S43.8,10.4,43.8,18S37.6,31.8,30,31.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M29.6,23.7c-0.9,0-1.5,0.7-1.5,1.6c0,0.9,0.6,1.6,1.5,1.5c0.9,0,1.5-0.6,1.5-1.5 C31.1,24.3,30.5,23.7,29.6,23.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M30,9.6c-1.4,0-2.8,0.4-3.6,1l0.6,1.6c0.6-0.5,1.6-0.8,2.5-0.8c1.6,0,2.4,0.8,2.4,2.1c0,1.1-0.6,2.1-1.7,3.4 c-1.2,1.5-1.6,3-1.5,4.3v0.6v0.1h2v-0.6c-0.1-1.3,0.3-2.4,1.4-3.7c1.2-1.4,2.1-2.6,2.1-4.3C34.2,11.4,32.9,9.6,30,9.6z"
}));

var SvgHelpCircle = function SvgHelpCircle(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "6 -6 48 48",
    style: {
      enableBackground: "new 6 -6 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelpCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help-circle.8d5d34cb.svg";
export { ForwardRef as ReactComponent };